import QuanLiTaiSanPage from 'components/quan-li-tai-san/QuanLiTaiSanPage';
import { ASSET_SOURCE } from 'config/constants/assetConstant';
import React from 'react';

function MamNonQuanLiTaiSanPage() {
    return <QuanLiTaiSanPage assetSource={ASSET_SOURCE.MAMNON}></QuanLiTaiSanPage>;
}

export default MamNonQuanLiTaiSanPage;
